import React, { useMemo } from 'react';
import styles from './index.module.less';
import { useRouter } from 'next/router';
import { HomeArticleModel } from '@/types/home';
import { Col, Row } from 'antd';
import { imgUrl } from '@/shared/utils';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import dayjs from 'dayjs';

const CategoryTopContent = ({ list }: { list: HomeArticleModel[] }) => {
  const router = useRouter();

  const link = (model?: HomeArticleModel) => `/instagram-tracking-blog/${model.title_id}`;
  const handleClick = (model?: HomeArticleModel) => {
    router.push(link(model));
  };

  const getContent = useMemo(() => {
    return (
      <div className={styles.homeContent}>
        <Row>
          <Col sm={17} xs={15}>
            <div
              className={styles.leftContainer}
              onClick={() => {
                list?.length > 0 ? handleClick(list[0]) : undefined;
              }}
            >
              {list?.length > 0 && (
                <>
                  <Image
                    className={styles.image}
                    src={imgUrl(list[0].cover_image, 'big')}
                    alt={list[0].title}
                    loading="lazy"
                    width={660}
                    height={377}
                    layout="responsive"
                  />
                  <Link href={link(list[0])}>
                    <div className={styles.leftTitle}>{list[0].title}</div>
                  </Link>
                  <div className={styles.leftDesc}>{list[0].description}</div>
                  <div className={styles.time}>{dayjs(list[0].create_time).format('YYYY-MM')}</div>
                </>
              )}
            </div>
          </Col>
          <Col sm={7} xs={9} className={styles.rightContainer}>
            <div
              className={styles.rightItem}
              onClick={() => {
                list?.length > 1 ? handleClick(list[1]) : undefined;
              }}
            >
              {list?.length > 1 && (
                <>
                  <Image
                    className={styles.image}
                    src={imgUrl(list[1].cover_image, 'big')}
                    alt={list[1].title}
                    loading="lazy"
                    width={300}
                    height={171}
                    layout="responsive"
                  />
                  <Link href={link(list[1])}>
                    <div className={styles.rightTitle}>{list[1].title}</div>
                  </Link>
                  <div className={styles.time}>{dayjs(list[1].create_time).format('YYYY-MM')}</div>
                </>
              )}
            </div>
            <div
              className={classNames(styles.rightItem, styles.secondItem)}
              onClick={() => {
                list?.length > 2 ? handleClick(list[2]) : undefined;
              }}
            >
              {list?.length > 2 && (
                <>
                  <Image
                    className={styles.image}
                    src={imgUrl(list[2].cover_image, 'big')}
                    alt={list[2].title}
                    loading="lazy"
                    width={300}
                    height={171}
                    layout="responsive"
                  />
                  <Link href={link(list[2])}>
                    <div className={styles.rightTitle}>{list[2].title}</div>
                  </Link>
                  <div className={styles.time}>{dayjs(list[2].create_time).format('YYYY-MM')}</div>
                </>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }, [list, link, handleClick]);

  return <>{getContent}</>;
};

export default CategoryTopContent;
